var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('Breadcrumb'),_c('div',{staticClass:"information"},[_c('div',{staticClass:"content-slot"},[_vm._t("default")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }